import { useEffect } from 'react'
import { useClaimForm } from '../context/ClaimFormContext'

let fetched = false

export function useAppParams() {
  const { updateField } = useClaimForm()

  useEffect(() => {
    if (fetched) return
    fetched = true
    fetch('/api/claimform/appparams')
      .then((r) => r.ok ? r.json() : null)
      .then((params) => {
        if (params) updateField('appParams', params)
      })
      .catch(() => { fetched = false })
  }, [])
}
